// The Partes table grouped by one field: a board column with options (e.g.
// "Ubicación del parte"), the unit or the state. Pure -- tested by
// agruparPartes.test.mjs.
//
// agruparPartes(filas, valorDe, orden) -> [{ clave, filas, fs }]
//   valorDe(fila): the fila's group ('' or null = none);
//   orden: the known values in the order their groups go (a column's options);
//     values not in it follow, alphabetically; "none" goes last (clave '').
// Each group keeps the filas in the order given; `fs`: how many take a unit
// out of service. Empty groups are left out.
export function agruparPartes(filas, valorDe, orden = []) {
  const grupos = new Map()
  for (const f of filas) {
    const v = valorDe(f)
    const clave = v == null ? '' : String(v).trim()
    if (!grupos.has(clave)) grupos.set(clave, [])
    grupos.get(clave).push(f)
  }
  const pos = new Map(orden.map((v, i) => [String(v).toLowerCase(), i]))
  const claves = [...grupos.keys()].sort((a, b) => {
    if (a === '' || b === '') return a === '' ? 1 : -1
    const pa = pos.get(a.toLowerCase()), pb = pos.get(b.toLowerCase())
    if (pa != null || pb != null) return pa == null ? 1 : pb == null ? -1 : pa - pb
    return a.localeCompare(b, 'es', { numeric: true })
  })
  return claves.map(clave => {
    const fs = grupos.get(clave)
    return { clave, filas: fs, fs: fs.filter(f => f.implica_fs).length }
  })
}
